import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si no sé nada de tecnología?',
    a: 'Sí. Fue diseñada para empezar desde cero. Si sabés encender la computadora, podés empezar.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al pagar recibís el link de descarga por mail. Acceso en menos de 5 minutos. Tuyo para siempre.'
  }, {
    q: '¿Funciona si tengo más de 50 años?',
    a: 'Especialmente. El perfil 40+ tiene ventajas reales — responsabilidad, comunicación madura y experiencia de vida.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. Escribís a soportebibliotecasdigitales@gmail.com y te devolvemos todo.'
  }];
  return <section className="bg-nightDeep py-12" data-id="element-63">
      <div className="max-w-3xl mx-auto px-6" data-id="element-64">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-8 flex items-center justify-center gap-3" data-id="element-65">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-66">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-67" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="glass rounded-xl overflow-hidden" data-id="element-68">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 hover:bg-white/5 transition-colors text-left" data-id="element-69">
        <span className="font-bold text-lg text-white" data-id="element-70">{question}</span>
        <ChevronDown className={`w-5 h-5 text-gold-accent transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-71" />
      </button>
      <AnimatePresence data-id="element-72">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-73">
            <div className="p-5 pt-0 text-textLight border-t border-white/10" data-id="element-74">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}